import { Reminder } from 'models'

/**
 * Converts reminder response from Nagra to {@link Reminder} model
 * @param {Array<NagraReminder>} reminders
 * @returns {Array<Reminder>}
 */
export const remindersFactory = (reminders = []) => {
    if (!reminders.length) return []
    return reminders.map(
        (reminder) =>
            new Reminder({
                id: reminder.id,
                availabilityStart: reminder.metadata && reminder.metadata.startTime,
                availabilityEnd: reminder.metadata && reminder.metadata.endTime,
                eventId: reminder.contentId,
                channelId: reminder.metadata && reminder.metadata.channelId,
            })
    )
}

/**
 * Reminder structure from Nagra get reminders response
 * @typedef {Object} NagraReminder
 * @property {String} id - reminder id
 * @property {String} account - account id
 * @property {String} userId - user id
 * @property {String} deviceId - device id
 * @property {Date} eventTime - event start time
 * @property {String} contentId - content id
 * @property {String} contentType - content type
 * @property {String} name - reminder name
 * @property {Date} creationDate - creation date
 * @property {Date} modifiedDate - modified date
 * @property {Object} metadata - additional reminder data
 * @property {String} metadata.contentId - content id
 * @property {String} metadata.channelId - channel id
 * @property {Number} metadata.startTime - reminder start time
 * @property {Number} metadata.endTime - reminder end time
 * @property {Array} tags - reminder tags
 */
